import { Grid, IconButton, Typography } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import BaseTooltip from "../common/baseTooltip";
import GreenButtonStyled from "../styled/green.button.styled";
import { ReactComponent as FileExcelIcon } from "../../assets/icons/file-excel-icon.svg";
import { ReactComponent as HistoryIcon } from "../../assets/icons/history-icon.svg";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import BulkWalletsUpdateDialog from "./bulk.wallets.update.dialog";
import digitalWalletStore from "@/stores/digital.wallet.store";
import popupService from "@/services/popupService";
import { checkPermissionsWithoutAlert } from "@/util";
import { PermissionName } from "@/models/apiModels";
import TotalSumBalance from "./total.sum.balance";
import swal from "sweetalert2";

interface IDigitalWalletManagementOptionBar {
    waletSelectionModel: GridRowSelectionModel;
    setWalletSelectionModel: Function;
    searchClick: Function;
    exportCsv: () => void;
}

const DigitalWalletManagementOptionBar: FC<IDigitalWalletManagementOptionBar> = ({
    waletSelectionModel,
    setWalletSelectionModel,
    searchClick,
    exportCsv,
}: IDigitalWalletManagementOptionBar) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleClickOpen = async () => {
        if (!checkPermissionsWithoutAlert(PermissionName.WalletManagment)) {
            return;
        }
        const digitalWalletsList = digitalWalletStore.digitalWalletsStore;
        const rows = digitalWalletStore.walletSelectionModel;
        const digitalWalletsSelected = digitalWalletsList.filter((d) => rows.includes(d.id));
        let isExistWalletNotActive = digitalWalletsSelected.find((element) => element.walletStatus === "NotActive");
        const inActiveEmployees = digitalWalletsSelected.filter((element) => !element.employeeStatus);
        const hasOnlyNotActiveWallets = digitalWalletsSelected.every((wallet) => !wallet.employeeStatus);
        if (inActiveEmployees && inActiveEmployees.length > 0) {
            if (hasOnlyNotActiveWallets) {
                swal.fire({
                    icon: "error",
                    text: t("digitalWallet.error.oneSelectedAndOneInactive") as string,
                    showConfirmButton: true,
                });
                return;
            }
            if (digitalWalletsSelected.length > 1) {
                const swalResult = await swal.fire({
                    icon: "warning",
                    text: t("digitalWallet.error.someSelectedAndOneInactive") as string,
                    cancelButtonText: t("forms.No") as string,
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: t("forms.Yes") as string,
                });
                if (!swalResult.isConfirmed) {
                    return;
                }
                const arrayOfWalletIdOfInactiveEmployees = inActiveEmployees.map((x) => x.id);
                const newSelectedWallets = waletSelectionModel.filter(
                    (wallet) => !arrayOfWalletIdOfInactiveEmployees.includes(Number(wallet))
                );
                const resultArr: number[] = [];
                newSelectedWallets.forEach((element) => {
                    resultArr.push(Number(element));
                });
                digitalWalletStore.setWalletSelectionModel(resultArr);
                setWalletSelectionModel(newSelectedWallets);

                const digitalWalletsSelectedUpdated = digitalWalletsList.filter((d) => resultArr.includes(d.id));
                isExistWalletNotActive = digitalWalletsSelectedUpdated.find(
                    (element) => element.walletStatus === "NotActive"
                );
            }
        }
        if (!isExistWalletNotActive) {
            setOpen(true);
        } else {
            var msg = `${t("digitalWallet.youSelectedInactiveWalletsAlert")}<br>${t(
                "general.doYouWantToContinueAlert"
            )}`;
            popupService.showConfirm("", msg).then(function (res) {
                if (res.isConfirmed) {
                    setOpen(true);
                }
            });
        }
    };
    const handleClose = () => {
        setOpen(false);
        if (digitalWalletStore.updateWalletsAfterUpdate) {
            digitalWalletStore.setUpdateWalletsAfterUpdate(false);
            searchClick();
        }
    };
    return (
        <Grid
            sx={{
                display: "grid",
                gridTemplateColumns: "4fr 1fr",
            }}
        >
            <Grid>
                <TotalSumBalance></TotalSumBalance>
                <Typography
                    sx={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "19px",
                        color: "#586A84",
                        paddingTop: "15px",
                    }}
                >
                    {t("digitalWallet.MoneyLoadUpdateWalletExpiryDates")}
                </Typography>
            </Grid>
            <Grid
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gridColumnGap: "18px",
                }}
            >
                <Grid>
                    <BaseTooltip title={t("employee.import.exportTitle")}>
                        <IconButton type="button" className="excel-btn" onClick={exportCsv}>
                            <i className="icon-f icon-Excel fs-24" />
                        </IconButton>
                    </BaseTooltip>
                </Grid>
                <Grid>
                    <GreenButtonStyled disabled={waletSelectionModel.length === 0} onClick={handleClickOpen}>
                        {t("digitalWallet.LoadUpdateParameters")}
                    </GreenButtonStyled>

                    <BulkWalletsUpdateDialog open={open} handleClose={handleClose}></BulkWalletsUpdateDialog>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DigitalWalletManagementOptionBar;
